import React, { useRef, useEffect, useState } from "react"
import { z } from "zod"
import axios from "axios"
import Form from "./elements/Form"
import Recaptcha from "./elements/Recaptcha"
import TermsConditions from "./elements/TermsConditions"
import TextInput from "./elements/TextInput"
import DatePicker from "./elements/DatePicker"
import Select from "./elements/Select"
import { SCHEMA } from "./schemas"
import {
  SUCCESS_MSG,
  formTracking,
  isCaptchaMode,
  postFormData,
  sendMail,
} from "./utils"

const FORM_SCHEMA = z.object({
  name: SCHEMA.name,
  email: SCHEMA.email,
  telephone: SCHEMA.telephone,
  postCode: SCHEMA.string,
  preferredDate: SCHEMA.select,
  preferredTime: SCHEMA.select,
})

const ValuationForm = ({ cta, formname, toEmail }) => {
  const recaptchaRef = useRef()
  const [selectedDate, setSelectedDate] = useState(null)
  const timeOptions = [ 
    { label: "10:00 AM", value: "10:00 AM" },
    { label: "10:30 AM", value: "10:30 AM" },
    { label: "11:00 AM", value: "11:00 AM" },
    { label: "11:30 AM", value: "11:30 AM" },
    { label: "12:00 PM", value: "12:00 PM" },
    { label: "12:30 PM", value: "12:30 PM" },
    { label: "1:00 PM", value: "1:00 PM" },
    { label: "1:30 PM", value: "1:30 PM" },
    { label: "2:00 PM", value: "2:00 PM" },
    { label: "2:30 PM", value: "2:30 PM" },
    { label: "3:00 PM", value: "3:00 PM" },
    { label: "3:30 PM", value: "3:30 PM" },
    { label: "4:00 PM", value: "4:00 PM" },
    { label: "4:30 PM", value: "4:30 PM" },
    { label: "5:00 PM", value: "5:00 PM" },
    { label: "5:30 PM", value: "5:30 PM" },
    { label: "6:00 PM", value: "6:00 PM" } 
  ]
  // Get CSRF Token
  const [csrfToken, setCsrfToken] = useState("")
  useEffect(() => {
    // Fetch CSRF token from server
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get("/api/csrf-token")

        // console.log("csrfToken ==> response", response)

        setCsrfToken(response.data.csrfToken)
      } catch (error) {
        console.error("Error fetching CSRF token:", error)
      }
    }

    fetchCsrfToken()
  }, [])
  // Get CSRF Token

  const FORM_CONFIG = {
    form_name: formname,
    eventTracking: formname,
    admin: {
      toEmail: toEmail,
      subject: formname ? formname : "Valuation Form",
      heading: formname,
      description:
        "The following person has requested a callback through the website:",
    },
    user: {
      subject: formname,
      description:
        "A member of our team will be in touch to confirm if this appointment can take place. Please await confirmation of the appointment from one of our team.",
    },
    labelMap: {
      message: "Message",
      preferredDate: "Preferred Date",
      preferredTime: "Preferred Time",
    },
  }

  const onSubmit = async (data) => {
    const token = isCaptchaMode
      ? await recaptchaRef.current?.executeAsync()
      : true

    if (token) {
      const postData = {
        firstName: data.name?.split(" ")[0],
        first_name: data.name?.split(" ")[0],
        ...data,
        _csrf: csrfToken,
        "g-recaptcha-response": token,
        ...FORM_CONFIG,
        extra: { formConfig: FORM_CONFIG, _csrf: csrfToken, data },
      }

      const formData = new FormData()

      formData.append("data", JSON.stringify(postData))

      postFormData(formData).then(async () => {
        await sendMail(postData)
      })

      recaptchaRef.current.reset()
      formTracking({
        eventTracking: FORM_CONFIG.eventTracking,
        formName: FORM_CONFIG.form_name,
      })
    }
  }

  return (
    <div className="contact-team-form-section popup-form-section custom-form-wrap">
      <Form
        className="contact-team-form popup-form"
        validationSchema={FORM_SCHEMA}
        onSubmit={onSubmit}
        successMsg={SUCCESS_MSG}
      >
        <TextInput name="name" placeholder="" label="Name" />
        <TextInput
          name="email"
          placeholder=""
          type="email"
          label="Email Address"
        />
        <TextInput
          name="postCode"
          placeholder="Post Code"
          label="Post Code"
        />
        <TextInput name="telephone" placeholder="" type="tel" label="Phone" />
        <div className="form-grid">
          <DatePicker
            name="preferredDate"
            label="Preferred Date"
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
          <Select
            name="preferredTime"
            placeholder="Select Time"
            label="Preferred Time"
            options={timeOptions}
            menuPlacement="top"
            required
          />
        </div>
        <button className="button button-primary" type="submit">
          <span>{cta}</span>
        </button>
        <Recaptcha recaptchaRef={recaptchaRef} />
      </Form>
      <TermsConditions />
    </div>
  )
}

export default ValuationForm
